import { Injectable } from '@angular/core';
// import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Subject, Observable } from 'rxjs';


// import { AuthorizedHttpService } from "app/authorized-http.service";
import { Router } from "@angular/router";
import * as moment from 'moment';
import * as Rx from 'rxjs';
import { UserResource } from 'app/models/UserResource';
import { HttpClient } from "@angular/common/http";
import { environment } from "app/baseUrl";
import { CMSResource } from 'app/resources/cmsresource';

@Injectable()
export class LoginDataService {

	private loginWebWorkerRef: Worker
	private guardLogged: boolean
	toggleLoginRoute: boolean
	private htmlVisibility
	private loginUrl = environment['url'] + '/login';
	triggerLoginOutletMode: any
	showLoginAsOutlet: boolean

	public get islogged(): boolean {
		return this.guardLogged
	}
	public get isHtmlVisible(): boolean {
		return this.htmlVisibility
	}

	constructor(private _route: Router, private http: HttpClient) {
		this.startLoginWebWorker()
		const timeDiff: boolean = moment(
			parseInt(localStorage.getItem("_login_date")))
			.add(7, 'hours')
			.isAfter(moment.now())
		if (localStorage.getItem('_user') !== null &&
			localStorage.getItem('_x_auth_token') !== null &&
			localStorage.getItem('_login_date') !== null &&
			timeDiff) {
			this.toogleLoginGuard(true)
			this.htmlVisibility = true
		} else {
			this.toogleLoginGuard(false)
			this.htmlVisibility = false
		}
	}
	startLoginWebWorker() {
		this.showLoginAsOutlet = false
		this.triggerLoginOutletMode = new Subject()
		this.loginWebWorkerRef = new Worker('/assets/scripts/login-web-worker.js')
		Rx.fromEvent(this.loginWebWorkerRef, 'message').subscribe(e => {
			/* switch (e. data.message_type) {
				case 'lifecycle':
					if (e.data.message_body === 'init') {
						let _tmp_lofin_date = parseInt(localStorage.getItem("_login_date"))
						this.loginWebWorkerRef.postMessage({
							message_type: "countdown",
							message_body: isNaN(_tmp_lofin_date) ? -1 : _tmp_lofin_date
						})
					}
					break
				case 'action':
					if (e.data.message_body === 'logout') {
						this.showLoginAsOutlet = true
						this.logOutThroughOutlet()
					}
					break
			}
				*/
		})

	}
	logOutThroughOutlet() {
		this.loginWebWorkerRef.postMessage({
			message_type: "countdown",
			message_body: -1
		})
		localStorage.removeItem('_user')
		localStorage.removeItem('_x_auth_token')
		localStorage.removeItem('_login_date')
		this.toogleLoginGuard(false)
		this.triggerLoginOutletMode.next({
			action: "logout"
		})
	}

	logOut() {
		localStorage.removeItem('_user')
		localStorage.removeItem('_x_auth_token')
		localStorage.removeItem('_login_date')
		localStorage.removeItem("_sc"); //_selectedUser
		this.toogleLoginGuard(false)
		this.htmlVisibility = false
		this._route.navigate(['/login'])

	}
	private toogleLoginGuard(value) {
		this.guardLogged = value
		this.toggleLoginRoute = value
	}

	// logIn(user: string, pass: string): Observable<any> {
	// 	let usrdata = {
	// 		"username": user,
	// 		"password": pass
	// 	}
	// 	return this.http.post<any>(this.loginUrl, usrdata)
	// }

	validLogin(usrdata: any, callBack) {
		localStorage.setItem("_login_date", moment.now().toString())
		// localStorage.setItem("_x_auth_token", res.headers.get('X-AUTH-TOKEN'))
		localStorage.setItem("_user", btoa(usrdata));
		

		// activeaza routele in angular
		this.toogleLoginGuard(true)
		this.htmlVisibility = true
		console.log("usrdatausrdata", usrdata)
		// loginul nu este declansat de componenta principala
		if (!this.showLoginAsOutlet) {
			// this._route.navigate(['/contentmanagement'])

			this.getUserProfile(`admin/user/getProfile?userName=${usrdata}`).subscribe(
				body => {
					localStorage.setItem("_roleId", body.role.rid);
					/* if (body.role.rid === 1) { // admin
						this._route.navigate(['/home'])
					} else if (body.role.rid === 4) { // Publisher
						this._route.navigate(['/home'])
					} else if (body.role.rid === 5) { // EDITOR
						this._route.navigate(['/home'])
					} */
					callBack();
				},
				error => console.error(error))

		}

		// console.error("res", res)
		this.showLoginAsOutlet = false
		this.triggerLoginOutletMode.next({
			action: "hide"
		})

		// semnealizeaza WW sa incepa numaratoarea inversa
		this.loginWebWorkerRef.postMessage({
			message_type: "countdown",
			message_body: parseInt(localStorage.getItem("_login_date"))
		})
	}

	getUserProfile(url): Observable<any> {
		return this.http.get<any>(environment.url + url)
	}

	resetPassService(url, body): Observable<UserResource> {
		return this.http.post<UserResource>(environment.url + url, body)
	}
	
	resetPassword(url): Observable<CMSResource> {
		return this.http.get<CMSResource>(environment.url + url)
	}

}